import { Button } from "@chakra-ui/react";
import React from "react";

const PrimaryButton = ({ children, className, ...resProps }) => {
  return (
    <Button
      type="button"
      className={
        "text-white bg-green-500 hover:bg-green-600 py-2 px-4 rounded-lg disabled:bg-slate-400 disabled:cursor-not-allowed " +
        className
      }
      colorScheme="teal"
      {...resProps}
    >
      {children}
    </Button>
  );
};

export default PrimaryButton;
